module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10055.471eff10.jpg";